<template>
  <header class="card_title" :class="[{'end': isShowClose}, {'no-border': isNoBorder}]">
    <template v-if="title">
      <p class="text_color_primary text_size_16">
        {{ title }}
      </p>
      <i @click="close" v-if="isShowClose" class="iconfont icon-shanchu close"></i>
    </template>
    <slot></slot>
  </header>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isShowClose: {
      type: Boolean,
      default: false
    },
    isNoBorder: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
  .card_title {
    display: flex;
    align-items: center;
    width: 100%;
    height: 60px;
    border-bottom: 1px solid $border-color-base;
    color: $color-text-primary;
    // 如果需要加上20px的left-pading
    &_padding_20 {
      padding-left: 20px;
    }
  }
  .end {
    display: flex;
    justify-content: space-between;
  }
  .close {
    font-size: 18px;
    cursor: pointer;
    transition: all 0.3s ease;
    &:hover {
      color: $color-primary;
    }
  }
  .no-border {
    border: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/border-title.vue